import './subtitle.scss'


const Subtitle = (
  {
    title = '关于焕泽',
    en = 'ABOUT',
  }
) => {
  const enArr = en.split(',')

  return (
    <div className={'subtitle'}>
      <div className={'titleContainer'}>
        {
          enArr.length  === 1 ? en :
            <div>{enArr[0]} <br/> <span>{enArr[1]}</span>  </div>
        }
        <div className={'title'}>
          <p>{title}</p>
        </div>
      </div>
    </div>
  )
}

export default Subtitle
